/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 
define([
  "backbone"
], function(
  Backbone
) {

  return Backbone.Model.extend({

      initialize: function (attributes, options) {
        Backbone.Model.prototype.initialize.apply(this, arguments);

        if (options && options.mainpartBinding) {
          this.listenTo(options.mainpartBinding, "change", this._mainpartBindingChanged);
        }
      },

      _mainpartBindingChanged: function (model) {
        this.set("mainpart", model.get());
      }

  });

})
